import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from './auth/interceptors/auth-interceptor.service';
import { WithCredentialsInterceptorService } from './auth/interceptors/with-credentials-interceptor.service';
import {AuthRefreshInterceptorService} from './auth/interceptors/auth-refresh-interceptor.service';
export const interceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthRefreshInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: WithCredentialsInterceptorService, multi: true },
];
